import { SET_LOCALIZATION_STRING } from './actionTypes';
import initialState from 'store/initialState';

export default function(state = initialState.localizationString, action) {
  switch (action.type) {
    case SET_LOCALIZATION_STRING:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/localizationString/reducer.js